import { TextInput } from '@mantine/core';
import { useDebouncedCallback } from '@mantine/hooks';
import { IconSearch } from '@tabler/icons-react';
import { useTranslate } from '@tolgee/react';
import { useState } from 'react';

const SEARCH_DEBOUNCE_MS = 300;

type Props = {
  /** Appelé avec la saisie nettoyée, une fois la frappe temporisée. */
  onSearch: (value: string) => void;
};

/** Recherche de service d'urgence par nom ou FINESS géographique (filtre appliqué par le flow). */
const SusSearch = ({ onSearch }: Props) => {
  const { t } = useTranslate();
  const [value, setValue] = useState('');
  const debouncedSearch = useDebouncedCallback(
    (search: string) => onSearch(search.trim()),
    SEARCH_DEBOUNCE_MS,
  );

  const handleChange = (search: string) => {
    setValue(search);
    debouncedSearch(search);
  };

  return (
    <TextInput
      w={{ base: '100%', sm: 300 }}
      value={value}
      onChange={event => handleChange(event.currentTarget.value)}
      placeholder={t('admin.sus.search')}
      aria-label={t('admin.sus.search')}
      leftSection={<IconSearch size={16} stroke={1.5} aria-hidden />}
    />
  );
};

export default SusSearch;
